'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

exports.download = download;
exports.downloadForm = downloadForm;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function download(url) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var lnk = document.createElement('a');
  lnk.href = url;
  // lnk.target = '_blank'; // FF blocks new windows by default
  lnk.download = fileName;
  if (document) {
    document.body.appendChild(lnk);
    lnk.click();
    document.body.removeChild(lnk);
  }
  lnk = null;
}

function downloadForm(url, fields) {
  var form = document.createElement('form');
  form.action = url;
  form.method = 'POST';

  (0, _entries2.default)(fields).map(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        name = _ref2[0],
        val = _ref2[1];

    var fld = document.createElement('input');
    fld.type = 'hidden';
    fld.name = name;
    fld.value = val;
    form.appendChild(fld);
  });

  form.submit();
  form = null;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/downloads.js
// module id = 262
// module chunks = 1